// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as EditorialRouteImport } from './routes/_editorial'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EditorialSobreRouteImport } from './routes/_editorial/sobre'
import { Route as EditorialCatalogoIndexRouteImport } from './routes/_editorial/catalogo/index'
import { Route as EditorialProdutoSlugRouteImport } from './routes/_editorial/produto/$slug'
import { Route as EditorialOcasioesOcasiaoRouteImport } from './routes/_editorial/ocasioes/$ocasiao'
import { Route as EditorialCatalogoCategoriaRouteImport } from './routes/_editorial/catalogo/$categoria'

const EditorialRoute = EditorialRouteImport.update({
            id: '/_editorial',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const EditorialSobreRoute = EditorialSobreRouteImport.update({
            id: '/sobre',path: '/sobre',getParentRoute: () => EditorialRoute
          })
const EditorialCatalogoIndexRoute = EditorialCatalogoIndexRouteImport.update({
            id: '/catalogo/',path: '/catalogo/',getParentRoute: () => EditorialRoute
          })
const EditorialProdutoSlugRoute = EditorialProdutoSlugRouteImport.update({
            id: '/produto/$slug',path: '/produto/$slug',getParentRoute: () => EditorialRoute
          })
const EditorialOcasioesOcasiaoRoute = EditorialOcasioesOcasiaoRouteImport.update({
            id: '/ocasioes/$ocasiao',path: '/ocasioes/$ocasiao',getParentRoute: () => EditorialRoute
          })
const EditorialCatalogoCategoriaRoute = EditorialCatalogoCategoriaRouteImport.update({
            id: '/catalogo/$categoria',path: '/catalogo/$categoria',getParentRoute: () => EditorialRoute
          })





const EditorialRouteChildren = {
  EditorialSobreRoute: EditorialSobreRoute,EditorialCatalogoCategoriaRoute: EditorialCatalogoCategoriaRoute,EditorialOcasioesOcasiaoRoute: EditorialOcasioesOcasiaoRoute,EditorialProdutoSlugRoute: EditorialProdutoSlugRoute,EditorialCatalogoIndexRoute: EditorialCatalogoIndexRoute
}

const EditorialRouteWithChildren = EditorialRoute._addFileChildren(EditorialRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,EditorialRoute: EditorialRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)